// SPDX-License-Identifier: AGPL-3.0-or-later

import type { Finding } from '@intakeform/ui';

export interface FindingsListProps {
  findings: Finding[];
  title?: string;
}

export function FindingsList({ findings, title = 'Findings' }: FindingsListProps) {
  if (findings.length === 0) {
    return (
      <p className="muted" data-empty="findings">
        No findings.
      </p>
    );
  }
  return (
    <section>
      <h3 className="section-title">{title}</h3>
      <ul className="finding-list">
        {findings.map((f, idx) => (
          <li key={`${f.linkId ?? 'form'}-${idx}`} className={`finding ${f.severity}`}>
            <strong>{f.severity}</strong>
            {f.linkId ? <span className="muted"> · {f.linkId}</span> : null} —{' '}
            <span>{f.message}</span> <code className="muted">{f.code}</code>
          </li>
        ))}
      </ul>
    </section>
  );
}
